import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AuthShell from '../../ui/AuthShell';
import Card from '../../ui/Card';
import Input from '../../ui/Input';
import Button from '../../ui/Button';
import { MailOutlined } from '@ant-design/icons';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { useToast } from '../../ui/ToastProvider';
import './auth.css';

const ForgotPasswordScreen = () => {
  const auth = getAuth();
  const { notify } = useToast();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      notify({ title: 'Email required', description: 'Please enter your email address.' });
      return;
    }
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      notify({ title: 'Email sent', description: 'Check your inbox for the reset link.' });
    } catch (error) {
      const code = error?.code || '';
      const msg = code === 'auth/user-not-found' ? 'No user found with this email.' : 'Failed to send reset email. Please try again.';
      notify({ title: 'Reset failed', description: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell>
      <Card className="auth-form-wrapper" style={{ padding: 24 }}>
        <div className="auth-header" style={{ textAlign: 'center', marginBottom: 8 }}>
          <h2 style={{ margin: '12px 0 6px', fontWeight: 700, color: '#0f172a' }}>Reset password</h2>
          <p style={{ margin: 0, color: '#334155' ,marginBottom: 24}}>Enter your email to receive a reset link.</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontWeight: 600, marginBottom: 6 }}>Email address</label>
            <div style={{ position: 'relative' }}>
              <MailOutlined style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#8c8c8c' }} />
              <Input
                type="email"
                placeholder="you@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: '100%', paddingLeft: 36 }}
                autoComplete="email"
              />
            </div>
          </div>
          <div>
            <Button type="submit" disabled={loading} className="vs-btn vs-btn-primary auth-form-button" style={{ width: '100%' }}>
              {loading ? 'Sending…' : 'Send reset email'}
            </Button>
          </div>
          <div style={{ textAlign: 'center', marginTop: 12 }}>
            Remembered your password? <Link to="/auth/login" className="auth-form-link">Sign in</Link>
          </div>
        </form>
      </Card>
    </AuthShell>
  );
};

export default ForgotPasswordScreen;
